import React from "react";
import { Link } from "react-router-dom";

import "../SignupPages/SignupCommon.css";
import "../SignupPages/Signup6.css";
import PageWrapper from "../SignupPages/PageWrapper";
const DisqualifyNadPlusPage: React.FC = () => {
    return (
    <PageWrapper>
      <div className="signup-page-container container">
        <div className="signup-content">
          <div className="error-container">
            <div className="error-box">
              <h1 className="error-condition">
                It appears this medication might not be the best fit for you at the moment.
              </h1>
            </div>
            <span className="error-content">Your journey to wellness is personal and unique. The Claya app: Your personalized weight loss companion</span>
            
            <Link to="https://claya.com/">
              <button className="next-btn">Explore claya membership</button>
            </Link>
          </div>
          <div style={{ paddingTop: "20px"}}>
            <span className="suffix-text-error">If you believe this is an error, please dont hesitate to contact us at <span className="suffix-support-email">support@claya.com</span> for assistance.</span>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default DisqualifyNadPlusPage;